import React, { useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
import { getLocaleWordContent } from '@/utils/language.util';
const SignInHelper = ({ remember, onSubmit, onChangeInput, handleKeyDown }) => {
    return (
        <div className="login">
            <div className="goto">
                <input
                    type="checkbox"
                    id="check"
                    name="remember"
                    checked={remember}
                    onChange={(e) => onChangeInput(e)}
                />
                <label htmlFor="check">{getLocaleWordContent('아이디저장')}</label> 
                {/* <div className="remember">
                    
                </div> */}
                {/* <Link to="/findid">회원가입</Link> */}
            </div>
            <div className="sub_btn_box">
                <input
                    type="button"
                    onClick={onSubmit}
                    onKeyPress={(e) => handleKeyDown(e)}
                    defaultValue={getLocaleWordContent('로그인')}
                    className="btn01"
                />
            </div>
        </div>
    );
};

function SignInInput({ userid, password, onChangeInput, remember, handleKeyDown }) {
    const inputUserId = useRef(null),
        inputPassword = useRef(null);

    useEffect(() => {
        const isFocus = window.setTimeout(() => {}, 300);
        return () => window.clearTimeout(isFocus);
    }, []);

    return (
        <form className="login">
            {/* <input style={{ opacity: '0', position: 'absolute' }} />
            <input
                type="password"
                style={{ opacity: '0', position: 'absolute' }}
                name="password_auto"
                autoComplete="off"
            /> */}
            <div className="input_form">
                <p className="title">ID</p>
                <input
                    type="text"
                    className="input01"
                    placeholder="ID"
                    name="user.userid"
                    value={userid}
                    onChange={(e) => onChangeInput(e)}
                    ref={inputUserId}
                    required
                />
            </div>
            <div className="input_form">
                <p className="title">{getLocaleWordContent('비밀번호')}</p>
                <input
                    type="password"
                    className="input01"
                    placeholder={getLocaleWordContent('비밀번호')}
                    name="user.password"
                    value={password}
                    onChange={(e) => onChangeInput(e)}
                    ref={inputPassword}
                    required
                    onKeyDown={(e) => handleKeyDown(e)}
                />
            </div>
        </form>
    );
}

export default function FormSignIn({ user, remember, onChangeInput, onSubmit }) {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onSubmit();
        }
    };

    return (
        <div className="inputbox">
            <SignInInput
                email={user.id}
                password={user.password}
                remember={remember}
                onChangeInput={onChangeInput}
                handleKeyDown={handleKeyDown}
            />
            <SignInHelper
                remember={remember}
                onChangeInput={onChangeInput}
                onSubmit={onSubmit}
                handleKeyDown={handleKeyDown}
            />
        </div>
    );
}
